import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let id = useDataValue({
    viewPath: props.viewPath,
    path: 'id',
    context: 'sort_filter',
  })

  let selected = useDataValue({
    viewPath: props.viewPath,
    path: 'selected',
    context: 'sort',
  })

  let change = useDataChange({
    context: 'sort',
    path: 'selected',
    viewPath: props.viewPath,
  })

  return function onClick() {
    let value = {
      ...Object.fromEntries(Object.keys(selected).map(key => [key, null])),
      [id]: 'asc',
    }
    change(value)
  }
}

export function isSelected(selected, id) {
  return selected[id] === 'asc'
}

export function getText(value) {
  if (value === 'due_date') {
    return `Earliest due date first`
  }
  if (value === 'priority') {
    return `Priority Low first`
  }
  if (value === 'created_at') {
    return `Created date oldest first`
  }
}
